/* eslint-disable react/prop-types */
import React from 'react'
import { useSvg } from 'irmlib/hooks'

/**
 * @function
 * @description Search
 * @param {object} props props.
 * @param {string} props.fill Fill color for the icon. By default, it picks up the color of the nearest parent.
 * @param {number} props.scale Scale for the size of the icon. The default is 1.
 * @returns {object} svg of the icon
 */
export default props => {
  const viewBoxWidth = 32
  const viewBoxHeight = 32
  const [fill, width, height] = useSvg(props, viewBoxWidth, viewBoxHeight)
  return (
    <svg width={width} height={height} viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`} version='1.1' xmlns='http://www.w3.org/2000/svg'>
      <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='search' transform='translate(4.000000, 3.000000)' fill={fill} fillRule='nonzero'>
          <path d='M24.6198914,23.5857669 L18.4569637,17.176013 C20.0415607,15.2923154 20.9097708,12.9222383 20.9097708,10.4548854 C20.9097708,4.69015249 16.2196183,0 10.4548854,0 C4.69015249,0 0,4.69015249 0,10.4548854 C0,16.2196183 4.69015249,20.9097708 10.4548854,20.9097708 C12.6190467,20.9097708 14.6813864,20.2570223 16.4446256,19.0178911 L22.6543729,25.4762829 C22.9139268,25.7458371 23.2630291,25.8944783 23.6371322,25.8944783 C23.9912346,25.8944783 24.3271546,25.7594739 24.5821629,25.5140114 C25.1239987,24.9926308 25.141272,24.1280572 24.6198914,23.5857669 Z M10.4548854,2.7273614 C14.715933,2.7273614 18.1824094,6.19383775 18.1824094,10.4548854 C18.1824094,14.715933 14.715933,18.1824094 10.4548854,18.1824094 C6.19383775,18.1824094 2.7273614,14.715933 2.7273614,10.4548854 C2.7273614,6.19383775 6.19383775,2.7273614 10.4548854,2.7273614 Z' id='Shape'></path>
        </g>
      </g>
    </svg>
  )
}
